export default BaseTreeNode = ({ children, id, testId, label, rest... }) ->
  <span
    data-testid={testId}
    {rest...}
  >
    <span style={{ marginRight: '5px' }}>{ label }</span>
    { children }
  </span>
